




import {
  defineComponent,
  ref,
  useContext,
  useRoute
} from '@nuxtjs/composition-api';
import { appStore } from '@/store';
import { setStrategy } from '@/utils/kkpp';

export default defineComponent({
  name: 'Login',
  layout: 'loading',
  setup() {
    const route = useRoute();
    const context = useContext();
    const form = ref<any>({});
    if (!route.value.query.continue) {
      document.cookie = `${appStore.appConfig.post_login_redirect_uri_cookie_name}=; max-age=0; domain=${appStore.appConfig.post_login_redirect_uri_cookie_domain}`;
    }
    if (Object.keys(route.value.query).length && !route.value.query.id) {
      // リダイレクトURLが設定されている場合クッキーにセット
      if (route.value.query.r) {
        document.cookie = `${appStore.appConfig.post_login_redirect_uri_cookie_name}=${route.value.query.r.toString()}; domain=${appStore.appConfig.post_login_redirect_uri_cookie_domain}`;
      }

      // ポータルでユーザー登録された後のログイン先へ飛ばす
      if (route.value.query.portal) {
        if (appStore.appConfig.baportal_url && appStore.appConfig.baportal_is_enable) {
          location.href = appStore.appConfig.baportal_url + 'login';
        } else {
          context.error({ statusCode: 404 });
        }
        return {};
      }

      // 強制再認証再認証するように求める
      if (route.value.query.force) {
        form.value.prompt = 'login';
      }
      // ブローカーの指定
      if (route.value.query.broker) {
        form.value.auth_method = 'broker';
        form.value.broker = route.value.query.broker;
      }
    }

    const ctx = useContext();
    ctx.$auth.loginWith(setStrategy(appStore.appConfig.bank_code), { params: form.value });
  }
});
